const o = {
  name: "Latvia",
  dimensions: { width: 22, height: 23 },
  content: `
    <g>
      <path d="M10.7598 9.83752V5.83752C10.7598 4.73752 11.2098 3.73752 11.9298 3.00752C12.6598 2.28752 13.6598 1.83752 14.7598 1.83752C16.9698 1.83752 18.7598 3.62752 18.7598 5.83752V13.8375" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M15.7598 6.83752C16.3121 6.83752 16.7598 6.38981 16.7598 5.83752C16.7598 5.28524 16.3121 4.83752 15.7598 4.83752C15.2075 4.83752 14.7598 5.28524 14.7598 5.83752C14.7598 6.38981 15.2075 6.83752 15.7598 6.83752Z" fill="currentColor" stroke="none"/>
      <path d="M18.7598 5.83752L20.7598 5.83752" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M13.7598 21.8375H9.75977V17.8375" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M1.75977 21.8375L10.7598 9.83752" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M4.75977 17.8375H14.7598C16.9698 17.8375 18.7598 16.0475 18.7598 13.8375C18.7598 11.6275 16.9698 9.83752 14.7598 9.83752H10.7598" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
  `
};
export {
  o as Latvia
};
